<template>
  <div class="rounded-md bg-white p-6 shadow-md">
    <div class="space-y-4">
      <h2 class="mb-2 text-center text-xl font-semibold text-gray-700">Últimos comprobantes</h2>
      <transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <Cargando v-if="isLoading" key="1" />
        <Empty key="2" v-else-if="deudas.length === 0" />
        <ListaDeudas v-else key="3" :deudas="deudas" />
      </transition>
    </div>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import ListaDeudas from '@/components/ListaDeudas'
import Cargando from '@/components/Core/Cargando'
import Empty from '@/components/Core/Empty'

export default {
  name: 'Home',

  components: { ListaDeudas, Cargando, Empty },

  mixins: [useService('portalPagos'), useSession()],

  data() {
    return {
      deudas: [],
      isLoading: true,
    }
  },

  async mounted() {
    let response = await this.portalPagos.getDeudas(
      this.user.cuitCuil.numero,
      'filter_name:FN_All,limit:10',
      'id:desc',
    )
    this.deudas = response.records
    this.isLoading = false
  },
}
</script>
